import { Children, cloneElement, isValidElement } from "react";
import type { ReactElement, ReactNode } from "react";

import { primeIcon } from "../icon";

const SEARCH_ICON = primeIcon("search", 14);

/**
 * O `MultiSelect` do Prime 10.9.8 não declara `filterIcon` nas props padrão e vazaria o atributo para o DOM:
 * o ícone de busca entra pelo `filterTemplate`, que troca o último filho (o ícone do Prime) do contêiner do filtro.
 */
export function searchFilterTemplate(options: { element: unknown }): ReactNode {
  const { element } = options;
  if (!isValidElement<{ children?: ReactNode }>(element)) return null;
  const [input] = Children.toArray(element.props.children);
  return cloneElement(
    element as ReactElement<{ children?: ReactNode }>,
    undefined,
    input,
    SEARCH_ICON({ iconProps: { className: "p-multiselect-filter-icon" } }),
  );
}
